import { render, staticRenderFns } from "./PersonInfo.vue?vue&type=template&id=36df0eac&scoped=true&"
import script from "./PersonInfo.vue?vue&type=script&lang=ts&"
export * from "./PersonInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PersonInfo.vue?vue&type=style&index=0&id=36df0eac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df0eac",
  null
  
)

export default component.exports